import axios from "axios";

// ============= ADMIN ALERTS =============

export const getAdminAlerts = (limit = 50) => async (dispatch) => {
  const res = await axios.get(`/api/admin/alerts?limit=${limit}`);
  return res.data;
};

export const getAdminAlertStats = () => async (dispatch) => {
  const res = await axios.get("/api/admin/alerts/stats");
  return res.data;
};

export const sendTestAlert = () => async (dispatch) => {
  const res = await axios.post("/api/admin/alerts/test");
  return res.data;
};

export const resolveAlert = (alertId) => async (dispatch) => {
  const res = await axios.put(`/api/admin/alerts/${alertId}/resolve`);
  return res.data;
};

export const getGroupedAlerts = (limit = 50) => async (dispatch) => {
  const res = await axios.get(`/api/admin/alerts/grouped?limit=${limit}`);
  return res.data;
};

export const getAlertTrends = (days = 7) => async (dispatch) => {
  const res = await axios.get(`/api/admin/alerts/trends?days=${days}`);
  return res.data;
};

export const getAlertsByFingerprint = (fingerprint, limit = 50) => async (dispatch) => {
  const res = await axios.get(`/api/admin/alerts/fingerprint/${fingerprint}?limit=${limit}`);
  return res.data;
};

export const resolveByFingerprint = (fingerprint) => async (dispatch) => {
  const res = await axios.put(`/api/admin/alerts/fingerprint/${fingerprint}/resolve`);
  return res.data;
};

export const updateAlertNotes = (alertId, notes) => async (dispatch) => {
  const res = await axios.put(`/api/admin/alerts/${alertId}/notes`, { notes });
  return res.data;
};

// ============= EMAIL SYSTEM =============

export const getEmailSchedulerStatus = () => async (dispatch) => {
  const res = await axios.get("/api/email/scheduler/status");
  return res.data;
};

export const triggerEmailScheduler = () => async (dispatch) => {
  const res = await axios.post("/api/email/scheduler/run");
  return res.data;
};

// ============= BACKUP SYSTEM =============
